import { HotelBookmarkModelBasePagingResponse } from '@/__generated';
import HotelJapaneseName from '@/components/App/Hotels/HotelJapaneseName';
import HotelStar from '@/components/App/Hotels/HotelStar';
import Spin from '@/components/Spin';
import { DEFAULT_PAGE_SIZE, HOTEL_CONFIG, UNKNOWN_ERROR_MESSAGE } from '@/config';
import { ModalUtils } from '@/contexts/ModalWrapper';
import { apiSdk } from '@/httpClient';
import { generateHotelDetailUrl } from '@/urls';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import { clearBookmarkHotelsData } from '@/hooks/dataProvider';

type Props = {};

export default function AgentBookmarkHotels({}: Props) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const { t } = useTranslation();

  const [searchParams, setSearchParams] = React.useState<any>({
    pageSize: DEFAULT_PAGE_SIZE,
    pageIndex: 1,
    orderBy: 'createdAt',
    orderByAsc: true,
  });
  const [hotelResponse, setHotelResponse] = React.useState<HotelBookmarkModelBasePagingResponse>();

  React.useEffect(() => {
    getData();
  }, [searchParams]);

  const getData = () => {
    setLoading(true);
    apiSdk.HotelBookmarkService.getHotelBookmarks(searchParams as any)
      .then(res => {
        setHotelResponse(res);
      })
      .catch(() => {
        ModalUtils.error({ content: UNKNOWN_ERROR_MESSAGE });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const onPageChange = (selectedItem: { selected: number }) => {
    setSearchParams(s => ({
      ...s,
      pageIndex: selectedItem.selected + 1,
    }));
  };
  const removeBookmarkHotel = (code: string) => {
    setLoading(true);
    apiSdk.HotelBookmarkService.remove({ hotelCode: code }).finally(() => {
      getData();
      clearBookmarkHotelsData();
    });
  };
  return (
    <div>
      <div className="row y-gap-20 justify-between items-end pb-10 lg:pb-40 md:pb-32">
        <div className="col-12">
          <h1 className="text-30 lh-14 fw-600">{t('agentBookmarkHotelPage_Title')}</h1>
          <div className="text-15 text-light-1">{t('agentBookmarkHotelPage_SubTitle')}</div>
        </div>
      </div>
      <div className="py-30 px-30 rounded-4 bg-white shadow-3">
        <Spin loading={loading}>
          <div className=" pt-30 ">
            <div className="row x-gap-30 y-gap-40">
              {hotelResponse?.data?.map(hotel => {
                return (
                  <div className="col-3 " key={hotel.hotelCode}>
                    <Link
                      to={generateHotelDetailUrl(hotel.hotelName, hotel.hotelCode)}
                      className="relative hotelsCard -type-1 hover-inside-slider shadow"
                    >
                      <div className="hotelsCard__image">
                        <div className="cardImage ratio ratio-1:1">
                          <div className="cardImage__content">
                            <div className="cardImage-slider rounded-4 overflow-hidden custom_inside-slider">
                              <Swiper
                                className="mySwiper"
                                modules={[Pagination, Navigation]}
                                pagination={{
                                  clickable: true,
                                }}
                                navigation={true}
                              >
                                {hotel?.images?.length ? (
                                  hotel?.images?.map((slide, i) => (
                                    <SwiperSlide key={i}>
                                      <img className="w-100 aspect-ratio-1-1 col-12 rounded-4" src={slide} alt="hotel" />
                                    </SwiperSlide>
                                  ))
                                ) : (
                                  <SwiperSlide>
                                    <img className="w-100 aspect-ratio-1-1 col-12 rounded-4" src={HOTEL_CONFIG.defaultImage} alt="hotel" />
                                  </SwiperSlide>
                                )}
                              </Swiper>
                            </div>
                          </div>
                        </div>
                        {/* End .cardImage */}

                        <div className="cardImage__wishlist">
                          <button
                            onClick={e => {
                              e.preventDefault();
                              removeBookmarkHotel(hotel.hotelCode || '');
                            }}
                            className={`button -red-1 bg-white border-light-1 size-40 rounded-full shadow bg-red-2`}
                          >
                            <i className="icon-heart text-12"></i>
                          </button>
                        </div>

                        <div className="cardImage__leftBadge"></div>
                      </div>
                      <div className="hotelsCard__content mt-10">
                        <h4 className="hotelsCard__title text-dark-1 text-18 lh-16 fw-500">
                          <span>{hotel?.hotelName}</span>
                          <HotelJapaneseName name={hotel.hotelNameJp} addBefore="-" />
                        </h4>

                        <p className="text-light-1 lh-14 text-14 mt-5">{hotel.address}</p>
                        <div className="d-flex items-center">
                          <HotelStar star={hotel.starRating || 0} />
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
            {hotelResponse && (hotelResponse.total || 0) > (hotelResponse.pageSize || 0) ? (
              <div className="agent-dashboard-paginate border-top-light mt-30 pt-30">
                <div className="total">Total records: {hotelResponse.total}</div>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel=">"
                  onPageChange={onPageChange}
                  pageRangeDisplayed={5}
                  forcePage={(hotelResponse?.pageIndex || 1) - 1}
                  pageCount={hotelResponse.total || 0}
                  previousLabel="<"
                  renderOnZeroPageCount={null}
                />
              </div>
            ) : null}
          </div>
        </Spin>
      </div>
    </div>
  );
}
